<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — ABOUT PAGE
     ════════════════════════════════════════════════ -->
<app-header-style-two></app-header-style-two>

<!-- Page Banner -->
<div class="page-title-area"
     [ngStyle]="{'background-image': 'url(' + createImgPath(getHeader_Img()) + ')'}">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li>{{"MENU.About" | translate}}</li>
        <li><a routerLink="/">{{"MENU.Home" | translate}}</a></li>
      </ul>
    </div>
  </div>
</div>

<!-- About Content -->
<section class="about-area">
  <div class="container">
    <div class="row align-items-center">

      <!-- Image -->
      <div class="col-lg-6 col-md-12">
        <div class="about-image">
          <img *ngIf="aboutUsPages?.img1"
               [src]="createImgPath(aboutUsPages?.img1)"
               alt="{{ aboutUsPages?.title }}">
        </div>
      </div>

      <!-- Text -->
      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <span class="sub-title">من نحن</span>
          <h2>{{ aboutUsPages?.title }}</h2>
          <p [innerHTML]="aboutUsPages?.fullText"></p>
          <a routerLink="/contact" class="btn btn-primary btn-lg" style="margin-top: 0.5rem;">
            <i class='bx bx-envelope'></i>
            {{"MENU.Contact" | translate}}
          </a>
        </div>
      </div>

    </div>
  </div>
</section>

